import { RuntimeNotifier, UUID } from "@opendaw/lib-std";
import { WclapDeviceBox, WclapInstrumentBox } from "@opendaw/studio-boxes";
// A plugin that cannot load passes audio through, the editor shows why, and this tells the user once per failure
export var WclapFailures;
(function (WclapFailures) {
    WclapFailures.report = (project, uuid, previous, status) => {
        if (status.state !== "failed" || previous?.state === "failed") {
            return;
        }
        const box = project.boxGraph.findBox(UUID.parse(uuid)).unwrapOrNull();
        const name = box instanceof WclapDeviceBox || box instanceof WclapInstrumentBox
            ? `"${box.label.getValue()}" (${box.clapId.getValue()})` : "A WebCLAP plugin";
        RuntimeNotifier.notify({
            message: `${name} could not load: ${status.message}. The device passes audio through.`,
            icon: "Warning"
        });
    };
})(WclapFailures || (WclapFailures = {}));
